import React from 'react'
import './index.scss'

interface IInputProps {
    value?: string
    place?: string
    onChange: (value: string) => void
}
const InputBox = (props: IInputProps) => {
    const { value, place, onChange } = props
    return (
        <div className="inputBox">
            <input
                className="setInput"
                value={value}
                placeholder={place}
                onChange={e => onChange(e.target.value)}
            ></input>
        </div>
    )
}

export default InputBox
